export { default as ProductsColorsFilterBadge } from './ProductsColorsFilterBadge';
